/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../../typings/globals/google.maps/index.d.ts" />

module Eseebase {
    export enum MapIconType {
        Building = 0,
        Landscape = 1,
        Unknown = 2,
        LocalizerWithModel = 3
    }
}